module.exports = __webpack_public_path__ + "static/media/carrent.75ca94df.png";